export default __webpack_public_path__ + "static/media/teamwork.178a6e3a.png";